module.exports = __webpack_public_path__ + "img/thumbnail_WestAfricanLion_m_normal.bec37614.png";